import { gql, useMutation } from '@apollo/client'

import {
  ArtistCreateOrganizationNotificationMutation,
  ArtistCreateOrganizationNotificationMutationVariables,
  OfficialInformationConsoleBoxFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useMessage, useRouter, useTranslation } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { t } = useTranslation('consoleOfficialInformationCreate')
  const { showMessage } = useMessage()
  const { router, routerPages } = useRouter()

  const [createOrganizationNotification] = useMutation<
    ArtistCreateOrganizationNotificationMutation,
    ArtistCreateOrganizationNotificationMutationVariables
  >(CREATE_ORGANIZATION_NOTIFICATION, {
    onCompleted() {
      showMessage(t('createSuccess'), 'success')
      router.goBack(routerPages.ConsoleOfficialInformations)
    },
  })

  return {
    state: {
      artistId: user?.uid ?? '',
    },
    actions: {
      async onSubmit({ title, body, status, link, publishedAt }) {
        await createOrganizationNotification({
          variables: {
            inputs: {
              title,
              body: body || null,
              status: status || null,
              link: link || null,
              publishedAt: publishedAt || undefined,
            },
          },
        })
      },
    },
  }
})

const CREATE_ORGANIZATION_NOTIFICATION = gql`
  mutation ArtistCreateOrganizationNotification(
    $inputs: ArtistCreateOrganizationNotificationInput!
  ) {
    artistCreateOrganizationNotification(inputs: $inputs) {
      ...OfficialInformationConsoleBox
    }
  }
  ${OfficialInformationConsoleBoxFragmentDoc}
`
